import Chart from 'chart.js'
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

  Chart.defaults.global.animationEasing        = 'easeInOutQuad',
  Chart.defaults.global.responsive             = true;
  Chart.defaults.global.scaleOverride          = true;
  Chart.defaults.global.scaleShowLabels        = false;
  Chart.defaults.global.scaleSteps             = 10;
  Chart.defaults.global.scaleStepWidth         = 10;
  Chart.defaults.global.scaleStartValue        = 0;
  Chart.defaults.global.maintainAspectRatio    = true;
  
export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    var ctx = this.renderChart(this.chartData, this.options)
 
    
  }
}